import React, { useContext } from "react";

import Link from "../Link";

import * as styles from "./component.module.less";
import { generateClassString as gcs } from "../../lib/helper/generateClassString";
import { createStructuredData } from "../../lib/helper/createStructuredData";

import { useIsDesktop } from "../../lib/hooks/mediaQueries";
import GeneralPageContext from "../../templates/GeneralPageContext";

export function Breadcrumb({ items = [], className: customClassName }) {
    const { type } = useContext(GeneralPageContext);
    const isMobile = useIsDesktop();

    const breadcrumbItems = items
        .filter(({ id, label, url }) => id && label && url)
        .map((item) => {
            return {
                ...item,
                label: item.label.replace(
                    /[^\(]+(\([^\)]+\))/gi,
                    (fullMatch, group) => {
                        return fullMatch.replace(group, "");
                    }
                )
            };
        });

    if (breadcrumbItems.length === 0) {
        return null;
    }

    const createBreadcrumbStructuredData = (breadcrumb) => {
        if (!breadcrumb || breadcrumb.length < 1) return [];
        var pos = 1;
        return {
            itemListElement: breadcrumb.map((item) => ({
                "@type": "ListItem",
                position: pos++,
                name: item.label,
                item: `${process.env.GATSBY_BASE_URL}${item.url}`
            }))
        };
    };

    return (
        <>
            {createStructuredData(
                "BreadcrumbList",
                createBreadcrumbStructuredData(breadcrumbItems)
            )}

            <div
                className={styles.breadcrumbWrapper}
                data-datocms-noindex={true}
            >
                <ol
                    className={gcs(styles.breadcrumb, customClassName, [
                        type === "news",
                        styles.dark
                    ])}
                    data-datocms-noindex={true}
                >
                    {breadcrumbItems.map(({ id, label, url }, i) =>
                        isMobile ? (
                            <li key={id}>
                                {i + 1 < breadcrumbItems.length && (
                                    <Link to={url}>{"..."}</Link>
                                )}
                                {i + 1 === breadcrumbItems.length && (
                                    <span>{label}</span>
                                )}
                            </li>
                        ) : (
                            <li key={id}>
                                {i + 1 < breadcrumbItems.length && (
                                    <Link to={url}>{label}</Link>
                                )}
                                {i + 1 === breadcrumbItems.length && (
                                    <span>{label}</span>
                                )}
                            </li>
                        )
                    )}
                </ol>
            </div>
        </>
    );
}
